import React, { PropTypes } from 'react';
import classNames from 'classnames';

import './styles.scss';


const Star = (props) => {
  const { number, filled, hovered, className, ...extra } = props;
  return (
    <li
      className={classNames('star', `star-${number}`, { filled, hover: hovered }, className)}
      {...extra}
      styleName='star'
    />
  );
};

Star.propTypes = {
  className: PropTypes.string,
  filled: PropTypes.bool.isRequired,
  hovered: PropTypes.bool,
  number: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
};

Star.defaultProps = {
  className: null,
  hovered: false,
  onClick: null,
  onMouseOver: null,
};

export default Star;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Star/index.jsx